import { motion, useReducedMotion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useRef } from 'react';
import confetti from 'canvas-confetti';
import { cn } from '@/lib/utils';

interface TaskCheckboxProps {
  checked: boolean;
  onToggle: () => void;
  className?: string;
  size?: number;
}

export function TaskCheckbox({ checked, onToggle, className, size = 22 }: TaskCheckboxProps) {
  const ref = useRef<HTMLButtonElement>(null);
  const reduce = useReducedMotion();

  // Dispara confetti a partir do centro do botao — somente ao MARCAR
  function fireConfetti() {
    if (reduce) return;
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    void confetti({
      particleCount: 36,
      spread: 55,
      startVelocity: 26,
      ticks: 70,
      origin: {
        x: (r.left + r.width / 2) / window.innerWidth,
        y: (r.top + r.height / 2) / window.innerHeight,
      },
      colors: ['#E10A17', '#FF4D5A', '#111111', '#FFFFFF'],
      disableForReducedMotion: true,
    });
  }

  return (
    <motion.button
      ref={ref}
      type="button"
      whileTap={{ scale: 0.85 }}
      onClick={(e) => {
        e.stopPropagation();
        if (!checked) fireConfetti();
        onToggle();
      }}
      role="checkbox"
      aria-checked={checked}
      // Quadrado rounded-[7px], borda 1.5px, transicao com easing back
      style={{
        width: size,
        height: size,
        borderRadius: 7,
        borderWidth: 1.5,
        transition: 'all var(--dur-fast) var(--ease-back)',
      }}
      className={cn(
        'inline-flex shrink-0 items-center justify-center border p-0',
        checked ? 'border-primary bg-primary' : 'border-border bg-transparent',
        className,
      )}
    >
      <motion.span
        initial={false}
        animate={
          checked ? { scale: 1, rotate: 0, opacity: 1 } : { scale: 0, rotate: -20, opacity: 0 }
        }
        transition={{ duration: 0.25, ease: [0.34, 1.56, 0.64, 1] }}
      >
        <Check className="text-primary-foreground" size={13} strokeWidth={3} />
      </motion.span>
    </motion.button>
  );
}
